import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type PaneType = 'dashboard' | 'jobs' | 'review' | 'edit' | 'admin' | 'config' | 'guide';

@Injectable()
export class PaneControlService {

	// Which panel is showed currently
	public currPane: BehaviorSubject<{
		paneType: PaneType;
		submenu?: string;
	}> = new BehaviorSubject(null);
	constructor() { }

}
